import { useEffect } from 'react';
import { ClientOnly } from 'components/_shared/widgets/render-control';
import stickyMessagesQuery from 'queries/messages.graphql';
import { useQuery } from '@apollo/client';
import { QueryMessagesOutput, StickyMessageInterface } from 'types/types';

interface StickyMessageLoaderProps {
  setStickyMessages: (messages: StickyMessageInterface[]) => void;
}

const StickyMessageLoader = ({
  setStickyMessages,
}: StickyMessageLoaderProps) => {
  const { data } = useQuery<QueryMessagesOutput>(stickyMessagesQuery);

  useEffect(() => {
    if (data?.messages) {
      setStickyMessages(data.messages);
    }
  }, [setStickyMessages, data]);

  return null;
};

/**
 * NOTE: we load these messages from server-side for most pages,
 * but for the ones below there is no SSR, so we load them from client-side instead.
 */
const Wrapper = (props: StickyMessageLoaderProps) => (
  <ClientOnly>
    <StickyMessageLoader {...props} />
  </ClientOnly>
);

export default Wrapper;
